import { pageView } from '@emico/datalayer-templates'
import { i18n } from '@emico/i18n/src'
import loginTokenVar from '@emico/login-token'

import dataLayer from './dataLayer'

export function pushPageView(pageType: string, pageCategory?: string) {
  const { locale } = i18n
  const loggedIn = Boolean(loginTokenVar())
  dataLayer.push(...pageView(pageType, pageCategory, locale, loggedIn))
}
